module.exports = __webpack_public_path__ + "static/media/productsuiteoverview.edaeeb07.gif";